import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './About.css';

const techs = [
  { name: 'React', icon: '⚛️' },
  { name: 'Express', icon: '🚂' },
  { name: 'MongoDB', icon: '🍃' },
   { name: 'MySQL', icon: '🗄️' },
  { name: 'Node.js', icon: '🟢' },
  { name: 'Python', icon: '🐍' },
  { name: 'C++', icon: '⚙️' },
  { name: 'HTML/CSS', icon: '🎨' },
   { name: 'JavaScript', icon: '⚡' },
  { name: 'GitHub', icon: '📦' },
  { name: 'Figma', icon: '🖌️' },
];

const About = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="about section-container" id="about" ref={ref}>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
      >
        <motion.h2 className="section-title" variants={itemVariants}>
          About Me
        </motion.h2>

        <motion.div className="about-content" variants={itemVariants}>
          <div className="about-text">
            <p>
              Hi, I'm Gayatri, a Computer Engineering student and software developer who enjoys building meaningful digital experiences and solving real-world problems through code.
            </p>
            <p>
              I focus on full-stack web development using modern JavaScript frameworks, with a keen eye for user experience. I love learning new technologies and guiding others along the way.
            </p>
            <p>
              I enjoy building reliable solutions with attention to detail and usability. I'm always open to learning, experimenting, and working with people who love creating impactful technology.
            </p>
          </div>
        </motion.div>

        <motion.div className="about-tech-section" variants={itemVariants}>
          <h3 className="about-tech-heading">Technologies & Tools</h3>
          <div className="tech-grid">
            {techs.map((tech, index) => (
              <motion.div
                key={tech.name}
                className="tech-item"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={inView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.4, delay: 0.4 + index * 0.05 }}
                whileHover={{ scale: 1.08, y: -4 }}
              >
                <span className="tech-icon">{tech.icon}</span>
                <span className="tech-name">{tech.name}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default About;